// extracted by mini-css-extract-plugin
module.exports = {"root":"Subtitle_root__2y9Kf","stickyToTop":"Subtitle_stickyToTop__1nbC8"};